import { Pipe, PipeTransform, NgModule } from '@angular/core';

@Pipe({ name: 'join', standalone: false })
export class JoinPipe implements PipeTransform {
  /**
   * Joins an array into a string with a separator
   * @param input - The array to join
   * @param character - The separator character
   * @returns Joined string
   */
  transform(input: unknown[], character: string = ''): string | unknown[] {
    if (!Array.isArray(input)) {
      return input;
    }
    return input.join(character);
  }
}

@NgModule({
  declarations: [JoinPipe],
  exports: [JoinPipe],
})
export class NgJoinPipeModule {}
